"use strict";

exports.__esModule = true;
var _SettingsMenu = require("./SettingsMenu");
Object.keys(_SettingsMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SettingsMenu[key]) return;
  exports[key] = _SettingsMenu[key];
});
var _AppNavbar = require("./AppNavbar");
Object.keys(_AppNavbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppNavbar[key]) return;
  exports[key] = _AppNavbar[key];
});
var _LegacyContext = require("./LegacyContext");
Object.keys(_LegacyContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LegacyContext[key]) return;
  exports[key] = _LegacyContext[key];
});
var _AppSidebar = require("./AppSidebar");
Object.keys(_AppSidebar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppSidebar[key]) return;
  exports[key] = _AppSidebar[key];
});
var _AppHomeScreen = require("./AppHomeScreen");
Object.keys(_AppHomeScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppHomeScreen[key]) return;
  exports[key] = _AppHomeScreen[key];
});
var _AppIcon = require("./AppIcon");
Object.keys(_AppIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppIcon[key]) return;
  exports[key] = _AppIcon[key];
});